import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default defineComponent({
  name: 'CategoryTags',
  components: {
    NuxtLinkCustom: NuxtLinkCustom
  },
  props: {
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});